import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullDealsTag from "./fragments/fullDealsTag"

const query = gql`
  query DealCategoriesForCurrentPackage {
    dealCategoriesForCurrentPackage {
      results {
        active
        image
        name
        onMenu
        url
        uuid
        type
        isGeolocationRelated
        tags {
          dealCount
          ...fullDealsTag
        }
        dealCount
      }
    }
  }
  ${fullDealsTag}
`

export const dealCategoriesForCurrentPackageKey = getQueryNames(query)[0]

export default query
